<div class="grid">
  <app-copiable-info label="SSID" icon="router" [value]="chargepoint?.ssid ?? 'Unknown'"></app-copiable-info>
  <app-copiable-info label="Firmware version" icon="system_update" [value]="chargepoint?.version ?? 'Unknown'"></app-copiable-info>
</div>

